import { render } from "./TheLanguagesList.vue?vue&type=template&id=07b6845a"
import script from "./TheLanguagesList.vue?vue&type=script&lang=js"
export * from "./TheLanguagesList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__